const ContentRoutes = {
  aboutUsContent: "/pages/aboutus",
  termsContent: "/pages/terms",
  privacy: "/pages/privacy",
  createContent: '/pages/update',
}

export default ContentRoutes